"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var LinkComponent = function LinkComponent() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var className = props.className,
      onClick = props.onClick,
      children = props.children,
      _props$data = props.data,
      data = _props$data === void 0 ? {} : _props$data;
  var dataSet = {};
  var key = '';

  for (key in data) {
    if (key.indexOf('data-') === 0) {
      dataSet[key] = data[key];
    }
  }

  return _react["default"].createElement("a", _extends({
    className: className,
    onClick: onClick
  }, dataSet), children);
};

var _default = LinkComponent;
exports["default"] = _default;